import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import TextLink from "hardcover-ui/components/TextLink";
import Badge from "hardcover-ui/components/Badge";
import pluralize from "lib/pluralize";
import truncate from "lodash/truncate";
import UserByline from "components/users/UserByline";
import { BookGroupSizeType, BookPromptContextType } from "../types";
import BookGroupHeaderWrapper from "./parts/BookGroupHeaderWrapper";
import PromptUserAnswersCount from "./parts/PromptUserAnswersCountLoader";
import LocaleNumber from "components/ui/LocaleNumber";

export default function BookPromptHeader({
  context,
  size,
}: {
  context: BookPromptContextType;
  size: BookGroupSizeType;
}) {
  return (
    <BookGroupHeaderWrapper size={size}>
      <div className="flex flex-row space-x-2 mb-1">
        <Text variant="secondary" as="p" size="sm" className="font-semibold">
          {context.prompt.featured && <span>Featured </span>}
          Prompt
        </Text>
        <Badge size="sm" variant="secondary">
          <LocaleNumber number={context.prompt.booksCount} />{" "}
          {pluralize("book", context.prompt.booksCount)}
        </Badge>
        <PromptUserAnswersCount promptId={context.prompt.id} />
      </div>

      <Heading level={3} size={size === "lg" ? "md" : "sm"} className="mb-2">
        {context.prompt.position >= 0 && <span>#<LocaleNumber number={context.prompt.position + 1} /> in </span>}
        <TextLink
          href={context.link ? context.link : `/prompts/${context.prompt.slug}`}
          underline={false}
        >
          {context.prompt.question}
        </TextLink>
      </Heading>

      {size === "lg" && (
        <Text variant="secondary" as="p">
          {truncate(context.prompt.description, {
            length: size === "lg" ? 200 : 140,
          })}
        </Text>
      )}

      <UserByline
        user={context.prompt.user}
        byline
        size="sm"
        className="mt-2"
      />
    </BookGroupHeaderWrapper>
  );
}
